import { useState, useContext, useEffect, createContext } from "react";
import UserService from '../services/userService';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Initialize auth state from localStorage on app load
    useEffect(() => {
        const initializeAuth = async () => {
            try {
                const storedUser = localStorage.getItem('user'); 
                const token = localStorage.getItem('token');

                if (storedUser && token) {
                    // validate token by fetching current user profile
                    try {
                        const userData = await UserService.getCurrentUser();
                        setUser(userData);
                    } catch (err) {
                        // if token is invalid, clear localStorage
                        localStorage.removeItem('user');
                        localStorage.removeItem('token');
                        setUser(null);
                    }
                }
            } catch (err) {
                console.error('Auth initialization error: ', err);
            } finally {
                setLoading(false);
            }
        }

        initializeAuth();
    }, []);

    // login function for admin
    const adminLogin = async (email, password) => {
        setLoading(true);
        setError(null);
 
        try {
            const data = await UserService.adminLogin(email, password);

            // store token and user data in localstorage
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            console.log("Data: ", data);
            setUser(data.user);
            console.log('I am here');
            return data.user;
        } catch (err) {
            console.log('Inside error');
            setError(err.response?.data?.message || 'login failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }

    // login function for user
    const login = async (email, password) => {
        setLoading(true);
        setError(null);
 
        try {
            const data = await UserService.login(email, password);
            // store token and user data in localstorage
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));

            setUser(data.user);
            console.log('I am here');
            return data.user;
        } catch (err) {
            console.log('Inside error');
            setError(err.response?.data?.message || 'login failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }


    // Register function
    const register = async (userData) => {
        setLoading(true);
        setError(null);

        try {
            const data = await UserService.register(userData);
            console.log('Register response :', data);

            // Store token and user data in localStorage
            localStorage.setItem("token", data.token)
            localStorage.setItem("user", JSON.stringify(data.user))

            setUser(data.user);
            return data.user;
        } catch (error) {
            console.log('Inside catch in AuthContext');
            setError(error.response?.data?.message || 'Registration failed');
            throw error;
        } finally {
            setLoading(false);
        }
    }

    // logout function 
    const logout = () => {
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        setUser(null)
    }

    // Update user profile
    const updateProfile = async (userData) => {
        setLoading(true)
        setError(null)

        try {
            const updatedUser = await UserService.updateProfile(userData)

            // Update stored user data
            localStorage.setItem("user", JSON.stringify(updatedUser))
            setUser(updatedUser)

            return updatedUser
        } catch (err) {
            setError(err.response?.data?.message || "Profile update failed")
            throw err
        } finally {
            setLoading(false)
        }
    }

    // check if useer is admin
    const isAdmin = () => {
        return user && user.isAdmin;
    }

    const value = {
        user,
        loading, 
        error,
        login,
        adminLogin,
        register,
        logout,
        updateProfile,
        isAdmin,
    }

    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
} 

